import { useSelector } from "react-redux";
import { ImageSlider } from "../components/home/ImageSlider";
import IPLMatchCardCompleted from "../components/home/IPLMatchCardCompleted";
import IPLMatchCardLive from "../components/home/IPLMatchCardLive";
import IPLMatchCardUpcoming from "../components/home/IPLMatchCardUpcoming";
import LiveTournaments from "../components/home/LiveTournaments";
import SportsChannels from "../components/home/SportsChannels";
import SportsFilter from "../components/home/SportsFilter";
import apiClient from "../utils/apiClient";
import { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";

const Home = () => {
  const tournaments =
    useSelector((state) => state.tournaments) || [];

  const [events, setEvents] = useState([]);
  const [loadingEvents, setLoadingEvents] =
    useState(false);

  const [activeFilter, setActiveFilter] =
    useState("all");

  // =========================
  // GET EVENTS
  // =========================

  const getEvents = async () => {
    try {
      setLoadingEvents(true);

      const response = await apiClient.post(
        "/public/get_events",
        {
          league_ids: tournaments?.map(
            (res) => res.league_id
          ),
        }
      );

      const result = await response?.data;

      if (result?.success) {
        setEvents(
          result.data?.filter(
            (res) => res.match_id
          )
        );
      }
    } catch (error) {
      console.log("Country API Error:", error);
    } finally {
      setLoadingEvents(false);
    }
  };

  useEffect(() => {
    if (tournaments.length > 0) {
      getEvents();
    }
  }, [tournaments]);

  // =========================
  // MATCH TYPES
  // =========================

  const liveMatches = events?.filter(
    (match) =>
      match?.match_live === "1" ||
      match?.match_status === "Live"
  );

  const upcomingMatches = events?.filter(
    (match) => {
      const isLive =
        match?.match_live === "1" ||
        match?.match_status === "Live";

      return (
        !isLive &&
        (!match?.match_status ||
          match?.match_status === "Upcoming")
      );
    }
  );

  const completedMatches = events?.filter(
    (match) => {
      const isLive =
        match?.match_live === "1" ||
        match?.match_status === "Live";

      const isUpcoming =
        !match?.match_status ||
        match?.match_status === "Upcoming";

      return !isLive && !isUpcoming;
    }
  );

  // =========================
  // FILTERED MATCHES
  // =========================

  const filteredMatches = events?.filter(
    (match) => {
      // LIVE
      const isLive =
        match?.match_live === "1" ||
        match?.match_status === "Live";

      // UPCOMING
      const isUpcoming =
        !isLive &&
        (!match?.match_status ||
          match?.match_status === "Upcoming");

      // COMPLETED
      const isCompleted =
        !isLive && !isUpcoming;

      // FILTERS
      if (activeFilter === "live") {
        return isLive;
      }

      if (activeFilter === "upcoming") {
        return isUpcoming;
      }

      if (activeFilter === "completed") {
        return isCompleted;
      }

      return true;
    }
  );

  return (
    <>
      <div className="p-4">

        <ImageSlider />

        {/* Home Page */}
        <div className="container mx-auto px-2 max-w-6xl">

          {/* FILTER */}
          <SportsFilter
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
            counts={{
              all: events?.length || 0,
              live: liveMatches?.length || 0,
              completed:
                completedMatches?.length || 0,
              upcoming:
                upcomingMatches?.length || 0,
            }}
          />

          {/* LOADER */}
          {loadingEvents && (
            <div className="flex justify-center py-6">
              <CircularProgress size={24} />
            </div>
          )}

          {/* MATCHES */}
          {!loadingEvents && (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">

              {filteredMatches?.map((match) => {

                // LIVE
                const isLive =
                  match?.match_live === "1" ||
                  match?.match_status === "Live";

                // UPCOMING
                const isUpcoming =
                  !isLive &&
                  (!match?.match_status ||
                    match?.match_status ===
                      "Upcoming");

                // COMPLETED
                const isCompleted =
                  !isLive && !isUpcoming;

                // LIVE CARD
                if (isLive) {
                  return (
                    <IPLMatchCardLive
                      key={match?.match_id}
                      match={match}
                    />
                  );
                }

                // UPCOMING CARD
                if (isUpcoming) {
                  return (
                    <IPLMatchCardUpcoming
                      key={match?.match_id}
                      match={match}
                    />
                  );
                }

                // COMPLETED CARD
                if (isCompleted) {
                  return (
                    <IPLMatchCardCompleted
                      key={match?.match_id}
                      match={match}
                    />
                  );
                }

                return null;
              })}

              {/* EMPTY */}
              {filteredMatches?.length === 0 && (
                <div className="col-span-full w-full flex items-center justify-center py-16">

                  <div className="text-center">

                    <div className="text-6xl mb-4">
                      ⚽
                    </div>

                    <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
                      No Match Found
                    </h3>

                    <p className="text-gray-500 dark:text-gray-400 mt-2">
                      No matches available right now.
                    </p>

                  </div>

                </div>
              )}

            </div>
          )}

        </div>

        <SportsChannels />

        <LiveTournaments />

      </div>
    </>
  );
};

export default Home;